const selectGiftCards = state => state.giftCards;

export const selectGiftCardsDiscountData = state =>
  selectGiftCards(state).discount.data;

export const selectGiftCardValuesData = state =>
  selectGiftCards(state).cardValues.data;

export const selectGiftCardsOrderAddress = state =>
  selectGiftCards(state).order.address;
export const selectGiftCardsOrderDirectDelivery = state =>
  selectGiftCards(state).order.directDelivery;
export const selectGiftCardsOrderCards = state =>
  selectGiftCards(state).order.giftCards;
export const selectGiftCardsOrderTotal = state =>
  selectGiftCards(state).order.total;

export const selectGiftCardsPayment = state => selectGiftCards(state).payment;

// eslint-disable-next-line no-underscore-dangle
export const selectGiftCardsRehydrated = state =>
  selectGiftCards(state)._persist?.rehydrated;
